<template>
    <div v-spinner="showSpinner" class="admin-person-info">
        <v-spinner :opacity="0.5">加载中...</v-spinner>
        <template v-if="adminInfo">
            <div class="admin-person-info-head">
                <img class="head-avatar" :src="adminInfo.icon" width="64" height="64" avatar="用户头像" />
                <div class="head-name">{{ adminInfo.login_account }}</div>
            </div>
            <div class="admin-person-info-main">
                <div class="main-title">登录管理</div>
                <div class="main-item">
                    <div class="item-label">手机</div>
                    <div v-if="!adminInfo.is_bind" class="item-value item-value--empty">
                        <div class="value-content">
                            <text-button @click="bindTelDialogVisiable = true">绑定</text-button>
                        </div>
                        <div class="value-desc">
                            绑定后可使用短信验证码登录<br />
                            用于登录账户中心进行管理操作，请务必使用管理员的个人手机号，避免企业信息泄漏
                        </div>
                    </div>
                    <div v-else class="item-value">
                        <div class="value-content">
                            <div class="value">{{ adminInfo.bind_mobile }}</div>
                            <v-tag class="bind-tag">已绑定</v-tag>
                            <text-button @click="changeBindConfirmTipVisiable = true">更换</text-button>
                        </div>
                        <div class="value-desc">
                            用于登录账户中心进行管理操作，请务必使用管理员的个人手机号，避免企业信息泄漏
                        </div>
                    </div>
                </div>
            </div>
            <!-- 通过给 dialog 使用 v-if 指令当 dialog close的时候，消除 dom 达到关闭dialog 清除表单错误信息的目的 -->
            <bind-tel-dialog
                v-model="bindTelDialogVisiable"
                v-if="bindTelDialogVisiable"
                @on-bind-success="handleBindSuccess"
            />
            <change-bind-tel-dialog
                v-model="changeBindConfirmTipVisiable"
                v-if="changeBindConfirmTipVisiable"
                :tel="adminInfo.bind_mobile"
                @on-change-success="handleBindSuccess"
            />
        </template>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import TextButton from '../components/text-button';
import BindTelDialog from '../components/bind-tel-dialog';
import ChangeBindTelDialog from '../components/change-bind-tel-dialog';
import Gateway from '@/utils/Gateway';

const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
export default {
    components: {
        TextButton,
        BindTelDialog,
        ChangeBindTelDialog
    },
    data() {
        return {
            bindTelDialogVisiable: false,
            changeBindConfirmTipVisiable: false,
            hasBindTel: false,
            adminInfo: null,
            showSpinner: false
        };
    },
    mounted() {
        this.fetchAdminInfo();
    },
    methods: {
        fetchAdminInfo() {
            this.showSpinner = true;
            Gateway.get('/v1/basic.account.account_web.AccountWeb/adminProfile')
                .then(res => {
                    this.adminInfo = res;
                    this.showSpinner = false;
                })
                .catch(err => {
                    this.showSpinner = false;
                    this.$message.error(err || '网络错误');
                    throw err;
                });
        },
        handleBindSuccess() {
            // 绑定/更换绑定手机成功
            this.fetchAdminInfo();
        }
    }
};
</script>
<style lang="less">
.admin-person-info {
    width: 900px;
    // min-height: 766px;
    height: 766px;
    margin: 20px auto 0;
    padding: 40px;
    background: #ffffff;
    border: 1px solid #ebedf2;
    box-sizing: border-box;
    border-radius: 4px;
    &-head {
        display: flex;
        align-items: center;
        .head-avatar {
            width: 64px;
            height: 64px;
            border-radius: 50%;
        }
        .head-name {
            margin-left: 20px;
            height: 36px;
            font-weight: 500;
            font-size: 26px;
            line-height: 36px;
            color: #1e2330;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    &-main {
        margin-top: 30px;
        .main-title {
            height: 26px;
            font-weight: 500;
            font-size: 18px;
            line-height: 26px;
            color: #1e2330;
            display: flex;
            align-items: center;
            &:before {
                content: '';
                display: block;
                width: 4px;
                height: 20px;
                background: #0067ed;
                margin-right: 5px;
            }
        }
        .main-item {
            display: flex;
            margin-top: 20px;
            .item-label {
                width: 100px;
                height: 20px;
                text-align: left;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #a8abb3;
            }
            .item-value {
                margin-left: 4px;
                .value-desc {
                    font-size: 12px;
                    line-height: 17px;
                    color: #a8abb3;
                    margin: 5px 0px;
                }
                .value-content {
                    display: flex;
                    align-items: center;
                    .bind-tag {
                        margin: 0 10px;
                    }
                }
            }
        }
    }
}
</style>
